import { STORE_CSRF_TOKEN } from '../constants';

const initialState = {
  csrfToken: null
};

export default (state = initialState, action = {}) => {
  //This is to ensure immutability of state
  let newState = { ...state };

  if (action.type == STORE_CSRF_TOKEN) {
    newState.csrfToken = action.data;
    return newState;
  }

  return state;
};
